import { EntitySortOrder } from '../enums';

const PERSONA_SORT_STORAGE_KEY = 'personaSortOrder';

export function readPersonaSortOrder(): EntitySortOrder {
  if (typeof window === 'undefined') return EntitySortOrder.MostRecent;
  try {
    const stored = localStorage.getItem(PERSONA_SORT_STORAGE_KEY);
    if (
      stored === EntitySortOrder.Alphabetical ||
      stored === EntitySortOrder.MostRecent
    ) {
      return stored;
    }
  } catch {
    console.error('Error reading persona sort order from localStorage');
  }
  return EntitySortOrder.MostRecent;
}

export function writePersonaSortOrder(order: EntitySortOrder): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(PERSONA_SORT_STORAGE_KEY, order);
  } catch {
    console.error('Error writing persona sort order to localStorage');
  }
}
